import { SearchRequestBody } from 'src/app/models/response.model';

interface TypeSelection {
  value: string;
  viewValue: string;
}

export const contentTypeSelection: TypeSelection[] = [
  { value: 'OTHER', viewValue: 'ANY_TYPE' },
  { value: 'DIRECTORY', viewValue: 'DIRECTORY' },
  { value: 'EXE', viewValue: 'EXE' },
  { value: 'IMAGE', viewValue: 'IMAGE' },
  { value: 'AUDIO', viewValue: 'AUDIO' },
  { value: 'VIDEO', viewValue: 'VIDEO' },
  { value: 'PDF', viewValue: 'PDF' },
  { value: 'TEXT', viewValue: 'TEXT' },
  { value: 'SPREADSHEET', viewValue: 'SPREADSHEET' },
  { value: 'PRESENTATION', viewValue: 'PRESENTATION' },
  { value: 'ARCHIVE', viewValue: 'ARCHIVE' },
];

export const ownerOptions: TypeSelection[] = [
  { value: 'MY_OBJECT', viewValue: 'MY_OBJECT' },
  { value: 'OTHER_USERS_OBJECT', viewValue: 'OTHER_USERS_OBJECT' },
  { value: 'SPECIFIC_USERS_OBJECT', viewValue: 'Belirli Bir Kullanıcıya Ait Dosyalar' },
];

export const searchCriteriaInitial: SearchRequestBody = {
  contentType: null,
  name: null,
  content: null,
  encrypted: false,
  favorited: false,
  trashed: false,
  parent: null,
  ownerOptions: null,
  email: null,
  beforeDate: null,
  afterDate: null,
  minSize: null,
  maxSize: null,
};

export const formDefaultValues = {
  contentType: 'OTHER',
  name: null,
  content: null,
  location: 'ALL',
  parentName: { disabled: true, value: null },
  parent: null,
  ownerOptions: 'MY_OBJECT',
  email: null,
  minSize: null,
  maxSize: null,
  minSizeOptions: 'KB',
  maxSizeOptions: 'KB',
  beforeDate: null,
  afterDate: null,
};
